import { render, staticRenderFns } from "./AlignCenter.vue?vue&type=template&id=ad776632&scoped=true&"
var script = {}
import style0 from "./AlignCenter.vue?vue&type=style&index=0&id=ad776632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad776632",
  null
  
)

export default component.exports